import React, {useCallback, useEffect, useRef, useState} from "react";
import PropTypes from "prop-types";

import pricingFeatureInterface from "./pricingFeatureInterface";
import {PRICING_FEATURE_PROPERTIES, PRICING_FEATURE_PROPERTIES_ARRAY} from "./pricingFeatureProperties";
import {getFeatureThumbnail} from "./pricingFeaturesFunctions";
import PricingCheckbox from "../PricingComponents/PricingCheckbox";
import PricingFeatureInput from "./PricingFeatureInput";


const PricingFeatureRow = (props) => {

  const {dbFeature, columns, style, index, presets, presetsReceived, featurePropertyChange, pricingEditedFeatures} = props;

  const getColumnValue = (property) => {
    const dbFeatureKey = PRICING_FEATURE_PROPERTIES[property].responseKey;
    const currentValue = pricingEditedFeatures[dbFeature.featureDefinition_id] && pricingEditedFeatures[dbFeature.featureDefinition_id].hasOwnProperty(property)
      ? pricingEditedFeatures[dbFeature.featureDefinition_id][property] || ""
      : dbFeature[dbFeatureKey] || "";
    switch (property) {
      case "name":
        if (!featurePropertyChange) {
          return <span className="color-textgray font--14 bold pr-two-lines">{currentValue || null}</span>
        }
        return <PricingFeatureInput onChange={featurePropertyChange}
                                    dbFeature={dbFeature}
                                    className="bold"
                                    value={currentValue}
                                    defaultValue={dbFeature[dbFeatureKey]}
                                    property={property}/>
      case "description":
        return <p className="margin-0 font--14 pr-two-lines">{currentValue}</p>
      case "thumbnail":
        return <div className="pr-grid-thumbnail" style={{
          backgroundImage: `url(${getFeatureThumbnail(currentValue)})`,
        }}/>
      case "priceGroup": {
        if (!presetsReceived) {
          return <div className="ui-loader ui-loader--small width-100"/>
        }
        const onGroupChange = (value) => {
          dbFeature.pricingProfileName = value;
        }
        return (
          <select
            className="radius-5 ui-input ui-input--gray4 ui-input--gray4--small ui-input--gray4--small--pr"
            value={dbFeature.pricingProfileName || ""}
            onChange={onGroupChange}>
            <option value="" disabled hidden>-</option>
            {presets.map((preset) => {
              return <option key={preset.name} value={preset.name}>{preset.name}</option>
            })}
          </select>
        )
      }
      default:
        if (!featurePropertyChange) {
          return currentValue || null
        }
        return <PricingFeatureInput onChange={featurePropertyChange}
                                    dbFeature={dbFeature}
                                    value={currentValue}
                                    defaultValue={dbFeature[dbFeatureKey]}
                                    property={property}/>
    }
  }

  return (
    <div className="grid pr-grid" style={style}>
      <div className="pr-grid-row">
        {PRICING_FEATURE_PROPERTIES_ARRAY.map(property => {
          if (!columns.includes(property)) {
            return null
          }
          if (property === "index") {
            return (
              <div className="pr-grid-cell flex flex--center line--16" key={property}>
                {index + 1}
              </div>
            )
          }
          if (property === "checkbox") {
            return (
              <div className="pr-grid-cell flex flex--center" key={property}>
                <PricingCheckbox id={dbFeature.featureDefinition_id}
                                 text={""}
                                 className="pr-checkbox--white min-h-125 flex flex--center"
                                 checked={false}
                                 onChange={() => null}/>
              </div>
            )
          }
          return (
            <div className={"pr-grid-cell flex flex--center line--16 flex--start pl-05 pr-05"} key={property}>
              {getColumnValue(property)}
              {/*<button className="ui-close ui-close--gray2 ui-close--small"/>*/}
            </div>
          )
        })}
      </div>
    </div>
  )
};

PricingFeatureRow.propTypes = {
  dbFeature: PropTypes.shape(pricingFeatureInterface),
  featurePropertyChange: PropTypes.func,
  pricingEditedFeatures: PropTypes.object.isRequired,
}

export default PricingFeatureRow
